import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, TemplateRef} from "@angular/core";
import {DimensionControlsService} from "./dimension-controls.service";
import {BIAttribute} from "../../draggable-attributes-list/bi-attribute";
import {FilterModel, provideFilterModel} from "../../../framework/bi/filter/filter.model";
import {Subscription} from "rxjs";
import {CubeDefinitionData} from "../../../framework/bi/cube-definition.data";
import {OrderProcessorCapability} from "../../../order-processing/order_processor/order-processor.data";

@Component({
    selector: "wbo-bi-draggable-member-select",
    templateUrl: "./draggable-member-select.component.html",
    styleUrls: ["./draggable-member-select.component.scss"],
    providers: [DimensionControlsService, provideFilterModel()]
})
export class DraggableMemberSelectComponent implements OnChanges, OnDestroy {

    OrderProcessorCapability = OrderProcessorCapability;

    @Input() label: string;

    @Input() dropZones: string[];

    @Input() cubeDefinition: CubeDefinitionData;

    /**
     * Data to give the drop area
     */
    @Input() data: BIAttribute;
    @Output() onDrop: EventEmitter<any> = new EventEmitter<any>();
    @Output() removed: EventEmitter<any> = new EventEmitter<any>();

    @Input() orderable: boolean;

    @Input() selectedFilterMembers: string[];

    @Output() selectedFilterMembersChange: EventEmitter<string[]> = new EventEmitter<string[]>();

    private subscriptions: Subscription = new Subscription();

    constructor(private filterModel: FilterModel, private dimensionControlsService: DimensionControlsService) {
        this.subscriptions.add(this.filterModel.filterDimensionUpdated$.subscribe((filterField) => {
            this.selectedFilterMembersChange.emit(filterField.members);
        }));
        this.subscriptions.add(this.dimensionControlsService.requestFormFieldRemoved.subscribe((field) => {
            this.removed.next(field);
        }));
    }

    get isDimension(): boolean {
        return this.data.type === BIAttribute.DIMENSION_TYPE;
    }

    get templateRef(): TemplateRef<any> {
        return this.dimensionControlsService.getRegisteredTemplateRef(this.data.id);
    }

    public dropped(e: any): void {
        this.onDrop.next(e);
    }

    public onRemoved(e: any): void {
        this.removed.next(e);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["data"]) {
            this.dimensionControlsService.currentField = this.data.id;
        }

        if (changes["selectedFilterMembers"]) {
            if (!this.filterModel.match(this.selectedFilterMembers, this.filterModel.getFilterMembers())) {
                this.filterModel.init(this.cubeDefinition, undefined, this.selectedFilterMembers);
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    remove(): void {
        this.dimensionControlsService.requestFormFieldRemoved.next(this.data.id);
    }
}
